/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Contact } from '../models/Contact';
import type { NewContact } from '../models/NewContact';
import type { PaginatedData_Contact_ } from '../models/PaginatedData_Contact_';
import type { PaginatedData_ContactView_ } from '../models/PaginatedData_ContactView_';
import type { PaginatedData_ContactWithCalls_ } from '../models/PaginatedData_ContactWithCalls_';
import type { Partial_Contact_ } from '../models/Partial_Contact_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactsService {
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns PaginatedData_ContactWithCalls_ Ok
     * @throws ApiError
     */
    public static getOpportunitiesContacts(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<PaginatedData_ContactWithCalls_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/opportunities/contacts/calls',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns PaginatedData_Contact_ Ok
     * @throws ApiError
     */
    public static getContacts(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<PaginatedData_Contact_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contacts',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Contact Ok
     * @throws ApiError
     */
    public static createContact(
        requestBody: NewContact,
    ): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/contacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns PaginatedData_ContactWithCalls_ Ok
     * @throws ApiError
     */
    public static getContactsWithCalls(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<PaginatedData_ContactWithCalls_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contacts/calls',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Contact Ok
     * @throws ApiError
     */
    public static updateContact(
        id: number,
        requestBody: Partial_Contact_,
    ): CancelablePromise<Contact> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/contacts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                404: `Resource not found.`,
            },
        });
    }
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns PaginatedData_ContactView_ Ok
     * @throws ApiError
     */
    public static getContactViews(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<PaginatedData_ContactView_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contacts/views',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
}
